import React from 'react';
import { Box, Typography } from '@mui/material';
import NewMfrRecipeForm from '../components/NewMfrRecipeForm';

const NewMfrRecipePage: React.FC = () => {
  const handleSuccess = () => {
    // Logic to handle successful form submission, such as redirecting or showing a success message
    console.log('Recipe created successfully');
  };

  return (
    <Box p={2}>
      <Typography variant="h4" gutterBottom>
        Add New Recipe
      </Typography>
      <NewMfrRecipeForm onSuccess={handleSuccess} />
    </Box>
  );
};

export default NewMfrRecipePage;
